import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("phone");
    navigate("/", { replace: true });
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Visualaey",
          text: "Revolutionize Face Recognition with AI-Powered Photo Sharing",
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    }
  };

  return (
    <>
      <div
        class="offcanvas offcanvas-bottom m-2 rounded-4 shadow border-0"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="d-flex align-items-center justify-content-center">
          <div
            className="circle-lg-btn bg-white rounded-circle mt-n8 z-1 position-relative"
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="bi bi-x-lg"></i>
          </div>
        </div>
        <div class="offcanvas-body">
          <div className="gradient-top rounded-top-4"></div>
          <div className="mt-2">
            <ul className="p-0 mb-2">
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/")}
              >
                <div className="text-dark menu-font">
                  <i className="bi bi-house me-3"></i>
                  Home
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/features")}
              >
                <div className="menu-font">
                  <i className="bi bi-grid me-3"></i>
                  Features
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/pricing")}
              >
                <div className="menu-font">
                  <i className="bi bi-wallet me-3"></i>
                  Pricing
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/book-demo")}
              >
                <div className="menu-font">
                  <i className="bi bi-camera me-3"></i>
                  Book a Demo
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/contact")}
              >
                <div className="menu-font">
                  <i className="bi bi-headset me-3"></i>
                  Contact Us
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <hr className="mx-2" />
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/privacy-policy")}
              >
                <div className="menu-font">
                  <i className="bi bi-journal me-3"></i>
                  Privacy Policy
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/terms")}
              >
                <div className="menu-font">
                  <i className="bi bi-info-circle me-3"></i>
                  Terms & Conditions
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
              <button
                className="btn w-100 border-0 text-start rounded-pill d-flex justify-content-between px-2 pe-0 py-0"
                data-bs-dismiss="offcanvas"
                type="button"
                onClick={() => navigate("/disclaimer")}
              >
                <div className="menu-font">
                  <i className="bi bi-info-circle me-3"></i>
                  Disclaimer
                </div>
                <div className="circle-sm-btn bg-light rounded-circle">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
            </ul>
          </div>
          <div className="gradient-bottom rounded-bottom-4"></div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg py-2 px-0 sticky-top my-header-bg z-5">
        <div className="container">
          <Link to="/">
            <img
              src="/assets/images/logo.png"
              width="130"
              className="me-lg-8"
            />
          </Link>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div>
              <div className="d-flex align-items-center">
                <div class="d-flex gap-2 align-items-center justify-content-end me-lg-6 me-5 d-lg-block d-none">
                  <a
                    href="https://www.facebook.com/share/1Ej8ZsML3e/?mibextid=wwXIfr"
                    target="_blank"
                  >
                    <i className="bi bi-facebook text-light fs-4 me-3"></i>
                  </a>
                  <a href="https://www.instagram.com/visualaey" target="_blank">
                    <i className="bi bi-instagram text-light fs-4 me-3"></i>
                  </a>
                  <a href="https://www.x.com/visualaey" target="_blank">
                    <i className="bi bi-twitter-x text-light fs-4"></i>
                  </a>
                </div>
                <Link
                  to="/book-demo"
                  className="btn fw-normal btn-gradient-bg-1 shadow-sm me-lg-3 px-5 d-none d-md-block text-white border-0 rounded-pill"
                >
                  Book a Demo
                </Link>
                <div className="d-lg-block d-none">
                  <div
                    class="avatar avatar-md bg-white rounded-circle d-flex justify-content-center align-items-center me-1 cursor-pointer"
                    onClick={handleShare}
                  >
                    <span className="d-flex justify-content-center align-items-center">
                      <img src="/assets/images/send.png" />
                    </span>
                  </div>
                </div>

                {!token ? (
                  <div className="bg-white inner-padding rounded-pill">
                    <Link
                      to="/login"
                      className="btn text-dark fw-normal ls-sm rounded-pill border-0 ms-2 px-lg-4 px-3 me-n1"
                    >
                      Login
                    </Link>
                    <Link
                      to="/signup"
                      className="btn bg-login-btn text-white fw-normal ls-sm px-5 rounded-pill border border-1"
                    >
                      Sign Up
                    </Link>
                  </div>
                ) : (
                  <>
                    <span class="rounded-circle ms-lg-0 me-1">
                      <div class="avatar avatar-md avatar-indicators avatar-online bg-light rounded-circle d-flex justify-content-center align-items-center">
                        <span
                          onClick={handleLogout}
                          className="cursor-pointer d-flex justify-content-center align-items-center"
                        >
                          <i className="bi bi-power fs-3 text-danger"></i>
                        </span>
                      </div>
                    </span>
                    <Link
                      to="/dashboard"
                      className="btn border-1 border-light text-white fw-normal me-2 px-4 me-lg-0 rounded-pill"
                    >
                      My Account
                    </Link>
                  </>
                )}

                <div className="d-lg-none d-block">
                  <a
                    data-bs-toggle="offcanvas"
                    href="#offcanvasExample"
                    role="button"
                    aria-controls="offcanvasExample"
                  >
                    <img
                      src="/assets/images/menu.png"
                      className="ms-3"
                      width="25"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav  mt-3 mt-lg-0">
              <li className="nav-item">
                <NavLink to="/" className="nav-link ps-0">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/features" className="nav-link">
                  Features
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/pricing" className="nav-link">
                  Pricing
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/contact" className="nav-link">
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
